export default __webpack_public_path__ + "static/media/contacts-location.34b6c44f.svg";